import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';
import { installationPointPhotosKey } from '@services/useInstallationPointPhotosQuery';

import { equipmentImagesListKey } from './useEquipmentImagesListQuery';

interface IProps {
  equipment_Id?: string;
  id?: number | string;
  nameplateId?: number | string;
  type?: string;
}

const deleteEquipmentImagesListFn = ({ equipment_Id, id, type, nameplateId }: IProps) => {
  return apiClient.delete(`${APP_API_URL_V2}fsd/equipment/${equipment_Id}/photos`, {
    params: {
      imageId: id,
      imageType: type,
      nameplateId: nameplateId,
    },
  });
};

export const useDeleteEquipmentImageMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteEquipmentImagesListFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [equipmentImagesListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [installationPointPhotosKey()[0]] });
    },
  });
};
